import { action, computed, observable, makeObservable } from 'mobx';
import { BetSlipFilter, BetSlipState } from 'src/domains/sportsbook/betting/state/BetSlipState';
import { getWindowInnerWidth } from 'src_common/common/mobx-utils/Services/window';
import { RabState } from 'src/domains/sportsbook/betting/state/rabState/RabState';
import { MultibetState } from 'src/domains/sportsbook/betting/state/multibetState/MultibetState';

export class BetWidgetsState {
    @observable public isBetslipWidgetVisible: boolean | null;

    public constructor(
        private readonly betSlipState: BetSlipState,
        private readonly rab: RabState,
        private readonly multibet: MultibetState
    ) {
        makeObservable(this);
        this.isBetslipWidgetVisible = null;
    }

    @computed public get isIndicatorVisible(): boolean {
        const { legsIds2, referralState } = this.betSlipState;
        const { activeBets: rabActiveBets } = this.rab;
        const { activeBets: multibetActiveBets } = this.multibet;
        const { isReferred } = referralState;

        const bets = legsIds2.length + rabActiveBets.length + multibetActiveBets.length;
        return isReferred ? false : bets > 0;
    }

    @computed public get isRemoveAllAvailable(): boolean {
        const { referralState, selectedTab } = this.betSlipState;
        const { isReferred } = referralState;
        return !isReferred && selectedTab === BetSlipFilter.BETSLIP && this.isIndicatorVisible;
    }

    @computed public get isMobile(): boolean {
        const widthInner = getWindowInnerWidth();
        return widthInner !== null && widthInner < 1024;
    }

    @action public removeAllTemporary = (): void => {
        const { betSlipSummaryState, onRemoveAllLegs } = this.betSlipState;
        const { clearError } = betSlipSummaryState;

        onRemoveAllLegs();
        this.rab.removeAllFromBetslip();
        this.multibet.removeAllFromBetslip();
        clearError();
    };
}
